import { useMemo } from "react";
import { resolveWidgetOrigin } from "./snippet";

/**
 * The widget origin for this deployment (`app.<domain>` → `book.<domain>`), overridable at build time via
 * `VITE_WIDGET_ORIGIN` — read directly (not via the typed `env`) to mirror the api-client mutator + MSW
 * handlers and to keep these surfaces out of `createEnv`'s required-var validation.
 */
export function useWidgetOrigin(): string {
  return useMemo(() => {
    const override =
      typeof import.meta.env?.VITE_WIDGET_ORIGIN === "string"
        ? import.meta.env.VITE_WIDGET_ORIGIN
        : undefined;
    const current = typeof window !== "undefined" ? window.location.origin : "";
    return resolveWidgetOrigin(current, override);
  }, []);
}
